import React, { ReactNode } from 'react';
import { FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css/free-mode';

import 'swiper/css';
import styles from './FadeSwiper.module.css';

export enum FadeSwiperVariant {
  PreviewRevisionStation = 'previewRevisionStation',
}

export type FadeSwiperProps<T> = {
  items: T[];
  maxPreviewCount?: number;
  children: (item: T, index: number) => ReactNode;
  childrenSlidesStylesVariant?: FadeSwiperVariant;
  childrenSlidesSpaceBetween?: number;
  noBgFadeEffect?: boolean;
};

export const FadeSwiper = <T,>(props: FadeSwiperProps<T>) => {
  const {
    items,
    maxPreviewCount,
    children,
    childrenSlidesStylesVariant,
    childrenSlidesSpaceBetween,
    noBgFadeEffect,
  } = props;

  let childrenStyle: string | undefined;

  switch (childrenSlidesStylesVariant) {
    case FadeSwiperVariant.PreviewRevisionStation:
      childrenStyle = styles.previewRevisionStation;
      break;
    default:
      childrenStyle = styles.slide;
      break;
  }

  return (
    <div className={styles.swiperContainer}>
      <div
        className={`${styles.fadeEffect} ${
          noBgFadeEffect ? styles.fadeLeftNoBg : styles.fadeLeft
        }`}
      />
      <Swiper
        modules={[FreeMode]}
        freeMode={{
          enabled: true,
          momentum: true,
          momentumRatio: 0.25,
          momentumVelocityRatio: 0.5,
        }}
        slidesPerView="auto"
        spaceBetween={childrenSlidesSpaceBetween ?? 8}
        className={styles.horizontalListView}
      >
        {items.slice(0, maxPreviewCount).map((item, index) => (
          <SwiperSlide key={index} className={`${childrenStyle}`}>
            {children(item, index)}
          </SwiperSlide>
        ))}
      </Swiper>
      <div
        className={`${styles.fadeEffect} ${
          noBgFadeEffect ? styles.fadeRightNoBg : styles.fadeRight
        }`}
      />
    </div>
  );
};
